// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1iB0o","noInteraction":"EventWrapper_noInteraction__195Yu","pointerPassthrough":"EventWrapper_pointerPassthrough__nXe7q"};